<template>
    <div class="dataStatistic">
        <div :id="'main-GZ' + id" class="item">

        </div>
        <div :id="'main-QC' + id" class="item">

        </div>
        <div :id="'main-XX'+ id" class="item">

        </div>
        <div  :id="'main-LX'+ id" class="item">

        </div>
    </div>
</template>

<script>
import option_GZ from "./option_GZ.js"
import option_QC from "./option_QC.js"
import option_XX from "./option_XX.js"
import option_LX from "./option_LX.js"
import { getCommonAjax } from "@/api/common"
export default {
    data() {
        return {
            id: new Date().getTime()
        };
    },

    mounted() {
        this.init();

    },

    methods: {
        init() {
            this.$nextTick(() => {
                getCommonAjax("/wxrw/count", {}).then(res => {
                    console.log(res);
                    var result = res.result;
                    this.initGZ(result.byGz);
                    this.initQC(result.byQc);
                    this.initXX(result.byXx);
                    this.initLX(result.byType);
                }).catch(err => {
                    console.log(err);
                });
            });

        },
        initGZ(arr) {
            option_GZ.series = [];
            var xData = this.getAllType(arr, 'gzType');
            var yData = this.getAllType(arr, 'type');
            var configColor = option_GZ.configColor();
            yData.forEach((item_y, index) => {
                var configItem = option_GZ.configItem();
                let data = [];
                xData.forEach(item_x => {
                    var val = this.getValArr(arr, item_x, item_y, 'gzType', 'type', 'num')
                    data.push(val);
                });
                configItem.name = item_y;
                configItem.data = data;
                configItem.itemStyle = configColor[index];

                option_GZ.series.push(configItem);
            })
            //
            option_GZ.xAxis.data = xData;

            this.$echarts.dispose(document.getElementById('main-GZ' + this.id));
            var myChart = this.$echarts.init(document.getElementById('main-GZ' + this.id));
            myChart.setOption(option_GZ, true);
            myChart.resize();
        },
        initQC(arr) {
            option_QC.series = [];
            var xData = this.getAllType(arr, 'qcName');
            var yData = this.getAllType(arr, 'type');
            var configColor = option_QC.configColor();
            yData.forEach((item_y, index) => {
                var configItem = option_QC.configItem();
                let data = [];
                xData.forEach(item_x => {
                    var val = this.getValArr(arr, item_x, item_y, 'qcName', 'type', 'num')
                    data.push(val);
                });
                configItem.name = item_y;
                configItem.data = data;
                configItem.itemStyle = configColor[index];

                option_QC.series.push(configItem);
            })
            //
            option_QC.xAxis.data = xData;

            this.$echarts.dispose(document.getElementById('main-QC' + this.id));
            var myChart = this.$echarts.init(document.getElementById('main-QC' + this.id));
            myChart.setOption(option_QC);
            myChart.resize();
        },
        initXX(arr) {
            option_XX.series = [];
            var xData = this.getAllType(arr, 'gzXx');
            var yData = this.getAllType(arr, 'type');
            var configColor = option_XX.configColor();
            yData.forEach((item_y, index) => {
                var configItem = option_XX.configItem();
                let data = [];
                xData.forEach(item_x => {
                    var val = this.getValArr(arr, item_x, item_y, 'gzXx', 'type', 'num')
                    data.push(val);
                });
                configItem.name = item_y;
                configItem.data = data;
                configItem.itemStyle = configColor[index];

                option_XX.series.push(configItem);
            })
            //
            option_XX.xAxis.data = xData;
            this.$echarts.dispose(document.getElementById('main-XX'+ this.id));
            var myChart = this.$echarts.init(document.getElementById('main-XX'+ this.id));
            myChart.setOption(option_XX);
            myChart.resize();
        },
        initLX(arr) {
            option_LX.calcData(arr, 'type', 'num')
            this.$echarts.dispose(document.getElementById('main-LX'+this.id));
            var myChart = this.$echarts.init(document.getElementById('main-LX'+this.id));
            myChart.setOption(option_LX);
            myChart.resize();
        },
        getAllType(arr, type) {
            var res = [];
            arr.forEach(item => {
                var val = item[type];
                if (!res.includes(val)) {
                    res.push(val);
                }
            });
            return res;

        },
        getValArr(arr, valX, valY, typeX, typeY, propNum) {
            let num = 0
            arr.some(item => {
                if (valX == item[typeX] && valY == item[typeY]) {
                    num = item[propNum];
                    return true; // 跳出循环
                }
            });

            return num;
        },
        getColorByCount(count, maxCount) {
            // 定义颜色梯度的起点和终点
            const startColor = [255, 0, 0]; // 红色
            const endColor = [0, 255, 0]; // 绿色

            // 将 count 映射到 [0, 1] 的区间内
            const normalizedCount = count / maxCount;

            // 计算每个颜色分量的差值，用于插值
            const colorDiff = endColor.map((value, index) => value - startColor[index]);

            // 插值，得到 count 对应的颜色
            return colorDiff.map((value, index) => Math.round(startColor[index] + value * normalizedCount));
        },
    },
};
</script>

<style lang="scss" scoped>
.dataStatistic {
    display: grid;
    grid-gap: 16px;
    overflow-y: hidden;
    overflow-x: hidden;
    grid-template: repeat(2, 1fr) / repeat(2, 1fr);
    height: 100%;
    box-sizing: border-box;

    .item {
        border: solid 1px #3AB0E3;
        width: 560px;
        height: 312px;
        box-sizing: border-box;
    }
}
</style>